/**
 * Top header bar.
 *
 * Contains the sidebar toggle, breadcrumb area, theme toggle,
 * and user profile dropdown.
 *
 * Cross-References:
 *   - Style Schema §2.2: Topbar (50px, sticky, z-100)
 *   - FR-UI-002: Header with profile menu
 *   - FR-UI-006: Mobile sidebar toggle
 */
import { Menu, Sun, Moon } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useUiStore } from '@/stores/uiStore';
import { useThemeStore } from '@/stores/themeStore';
import { useMediaQuery, BREAKPOINTS } from '@/hooks/useMediaQuery';
import { ProfileMenu } from './ProfileMenu';
import HelpPanel from './HelpPanel';
import GlobalSearchBar from './GlobalSearchBar';

export function Header() {
  const { toggleSidebar, setMobileSidebarOpen } = useUiStore();
  const { theme, toggleTheme } = useThemeStore();
  const isMobile = useMediaQuery(BREAKPOINTS.mobile);
  const { pathname } = useLocation();

  function handleMenuClick() {
    if (isMobile) {
      setMobileSidebarOpen(true);
    } else {
      toggleSidebar();
    }
  }

  return (
    <header className="header">
      <div className="header__left">
        <button
          className="btn btn--ghost header__menu-btn"
          onClick={handleMenuClick}
          aria-label="Toggle sidebar"
        >
          <Menu size={20} />
        </button>
      </div>
      <div className="header__center">
        <GlobalSearchBar />
      </div>
      <div className="header__right">
        <button
          className="btn btn--ghost"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
        </button>
        <HelpPanel currentPath={pathname} />
        <ProfileMenu />
      </div>
    </header>
  );
}
